import { JsonArrayPlaceholder } from './jsonArrayPlaceholder.js';
import { JsonKeyPlaceholder } from './jsonKeyPlaceholder.js';

/**
 * Purpose: Carries pre-parsed placeholder positions a loader may hand to the JSON merge.
 *
 * Responsibilities:
 * - Hold the parsed array blocks and scalar key placeholders of one template
 * - Keep "not parsed" (null list) distinct from "parsed" so the merge scans dynamically when absent
 * - Let the shared merge accept pre-parsed input without knowing which engine produced it
 */
export class PlaceholderIndex {
    readonly arrays: JsonArrayPlaceholder[] | null;
    readonly keys: JsonKeyPlaceholder[] | null;

    constructor(
        arrays: JsonArrayPlaceholder[] | null,
        keys: JsonKeyPlaceholder[] | null
    ) {
        this.arrays = arrays;
        this.keys = keys;
    }

    /**
     * Builds an index from parsed lists. An empty list carries nothing to reuse, so it is kept as
     * "not parsed" and the merge scans that kind dynamically.
     */
    static fromParsed(arrays: JsonArrayPlaceholder[], keys: JsonKeyPlaceholder[]): PlaceholderIndex {
        return new PlaceholderIndex(
            arrays && arrays.length > 0 ? arrays : null,
            keys && keys.length > 0 ? keys : null
        );
    }
}
